import { normalizeParticipantType } from "./csv.js";

export function normalizeRegistrationPayload(payload) {
  const participantType = normalizeParticipantType(payload.participantType);
  const normalized = {
    name: String(payload.name || "").trim(),
    email: String(payload.email || "").trim().toLowerCase(),
    password: String(payload.password || ""),
    participantType,
    professionalLicense: String(payload.professionalLicense || "").trim(),
    employeeCode: String(payload.employeeCode || "").trim()
  };

  if (!normalized.name) {
    throw new Error("Ingresa tu nombre completo.");
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized.email)) {
    throw new Error("Ingresa un correo electrónico válido.");
  }

  if (normalized.password.length < 6) {
    throw new Error("El password debe tener al menos 6 caracteres.");
  }

  if (participantType === "medico" && !normalized.professionalLicense) {
    throw new Error("Ingresa tu número de colegiado.");
  }

  if (participantType === "colaborador" && !normalized.employeeCode) {
    throw new Error("Ingresa tu código de colaborador.");
  }

  return normalized;
}
